// src/components/krums/ResumenKrums.js
import React from 'react';
import { Link } from 'react-router-dom';

const ResumenKrums = ({ saldo }) => {
  // Datos mock mientras no haya backend
  const krumsComprados = saldo?.krums_comprados || 120;
  const krumsGratis = saldo?.krums_gratis || 15;
  const imagenes = saldo?.imagenes_restantes || 8;

  return (
    <div className="resumen-krums">
      <h3>🔮 Tu Crisol</h3>
      <div className="resumen-detalle">
        <span>⚡ {krumsComprados + krumsGratis} Krums</span>
        <span>🖼️ {imagenes} imágenes</span>
      </div>
      <Link to="/krums" className="btn-ir-tienda">Ir a la tienda</Link>
    </div>
  );
};

export default ResumenKrums;